/* ==========================================================================
   DeVAR PREMIUM LUXURY INTERACTION & ANIMATION UTILITIES
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  initScrollReveal();
  initParallaxEffects();
  initTextRevealAnimations();
});

/**
 * Scroll Reveal using IntersectionObserver
 */
function initScrollReveal() {
  const revealElements = document.querySelectorAll('[data-reveal]');
  
  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const delay = entry.target.getAttribute('data-reveal-delay') || '0';
        const duration = entry.target.getAttribute('data-reveal-duration') || '600';
        
        entry.target.style.transitionDuration = `${duration}ms`;
        entry.target.style.transitionDelay = `${delay}ms`;
        
        entry.target.classList.add('reveal-active');
        
        // Stop observing once animated
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  });

  revealElements.forEach(element => {
    element.style.opacity = '0';
    element.style.transform = 'translateY(25px)';
    element.style.transitionProperty = 'opacity, transform';
    element.style.transitionTimingFunction = 'cubic-bezier(0.16, 1, 0.3, 1)';
    
    // Custom active state styles
    const style = document.createElement('style');
    style.innerHTML = `
      .reveal-active {
        opacity: 1 !important;
        transform: translateY(0) !important;
      }
    `;
    document.head.appendChild(style);
    
    revealObserver.observe(element);
  });
}

/**
 * Parallax effects for editorial banners and hero images
 */
function initParallaxEffects() {
  const parallaxWraps = document.querySelectorAll('[data-parallax-container]');
  
  if (parallaxWraps.length === 0 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  window.addEventListener('scroll', () => {
    const scrollY = window.pageYOffset;
    
    parallaxWraps.forEach(wrap => {
      const image = wrap.querySelector('[data-parallax-image]');
      if (!image) return;
      
      const speed = parseFloat(wrap.getAttribute('data-parallax-speed')) || 0.15;
      const rect = wrap.getBoundingClientRect();
      const offset = rect.top + scrollY - window.innerHeight;
      
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        const relativeScroll = (scrollY - offset) * speed;
        image.style.transform = `translate3d(0, ${relativeScroll}px, 0)`;
      }
    });
  }, { passive: true });
}

/**
 * Letter-by-letter or word-by-word reveal transitions for editorial headings
 */
function initTextRevealAnimations() {
  const textRevealHeaders = document.querySelectorAll('[data-text-reveal]');
  
  textRevealHeaders.forEach(header => {
    const text = header.textContent.trim();
    header.innerHTML = '';
    
    const words = text.split(' ');
    words.forEach(word => {
      const wordSpan = document.createElement('span');
      wordSpan.style.display = 'inline-block';
      wordSpan.style.overflow = 'hidden';
      wordSpan.style.verticalAlign = 'top';
      
      const letterSpan = document.createElement('span');
      letterSpan.textContent = word + '\u00A0';
      letterSpan.style.display = 'inline-block';
      letterSpan.style.transform = 'translateY(100%)';
      letterSpan.style.transition = 'transform 800ms cubic-bezier(0.16, 1, 0.3, 1)';
      
      wordSpan.appendChild(letterSpan);
      header.appendChild(wordSpan);
    });

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const spans = header.querySelectorAll('span > span');
          spans.forEach((span, index) => {
            setTimeout(() => {
              span.style.transform = 'translateY(0)';
            }, index * 40);
          });
          observer.unobserve(header);
        }
      });
    }, { threshold: 0.2 });
    
    observer.observe(header);
  });
}
